import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import OurStory from '../about/components/OurStory';
import TrustStats from '../about/components/TrustStats';
import MissionValues from '../about/components/MissionValues';
import WhoWeServe from '../about/components/WhoWeServe';
import ContactDetails from '../contact/components/ContactDetails';
import InquiryForm from './components/InquiryForm';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FAF8F5] to-[#F5F0EB]">
      <Navbar scrolled={scrolled} />

      {/* Home */}
      <div id="home">
        <Hero />
      </div>

      {/* Our Services */}
      <Services />

      {/* How It Works */}
      <HowItWorks />

      {/* About Us */}
      <div id="about">
        <OurStory />
        <TrustStats />
        <MissionValues />
        <WhoWeServe />
      </div>

      {/* Contact Us */}
      <div id="contact-us">
        <ContactDetails />
        <InquiryForm
          formId="home-contact-form"
          formUrl="https://readdy.ai/api/form/d71ks81lum2co2q1fpq0"
          sectionId="contact-form-section"
        />
      </div>

      <Footer />
    </div>
  );
}
